import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '聚焦二十大';
const baseUrl = '20221015JJ';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/focusing`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'focusing',
      name: `${baseUrl}-focusing`,
      component: () => import('./pages/Focusing.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'chongqing',
      name: `${baseUrl}-chongqing`,
      component: () => import('./pages/Chongqing.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'audiovisual',
      name: `${baseUrl}-audiovisual`,
      component: () => import('./pages/Audiovisual.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'headnews',
      name: `${baseUrl}-headnews`,
      component: () => import('./pages/focusing/HeadNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'processnews',
      name: `${baseUrl}-processnews`,
      component: () => import('./pages/focusing/ProcessNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'unscramblenews',
      name: `${baseUrl}-unscramblenews`,
      component: () => import('./pages/focusing/UnscrambleNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'scenenews',
      name: `${baseUrl}-scenenews`,
      component: () => import('./pages/focusing/SceneNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'focusnews',
      name: `${baseUrl}-focusnews`,
      component: () => import('./pages/chongqing/FocusNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'voicenews',
      name: `${baseUrl}-voicenews`,
      component: () => import('./pages/chongqing/VoiceNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'videonews',
      name: `${baseUrl}-videonews`,
      component: () => import('./pages/audiovisual/VideoNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'graphicnews',
      name: `${baseUrl}-graphicnews`,
      component: () => import('./pages/audiovisual/GraphicNews.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
